import { FormRow } from '@tanium/react-form';
import { FormTextInput } from '@tanium/react-form-text-input';
import { Field, FieldProps, FormikErrors } from 'formik';
import get from 'lodash.get';
import { getNullableEventValue } from 'utils/Helper';

type FormTextFieldProps = {
  fieldName: string;
  label: string;
  description: string;
  placeholder: string;
  dataTestId?: string;
  disabled?: boolean;
  required?: boolean;
  type?:
    | 'number'
    | 'search'
    | 'time'
    | 'text'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'month'
    | 'password'
    | 'tel'
    | 'url'
    | 'week'
    | undefined;
};

const FormTextField: React.VFC<FormTextFieldProps> = ({
  fieldName,
  label,
  description,
  placeholder,
  dataTestId,
  disabled = false,
  required,
  type,
}) => {
  let computedDataTestId = fieldName;
  if (dataTestId !== undefined) {
    computedDataTestId = dataTestId;
  }
  return (
    <Field name={fieldName}>
      {({ form, field }: FieldProps): React.ReactElement => (
        <FormRow
          label={label}
          description={description}
          labelId={field.name}
          required={required || false}
          errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
        >
          <FormTextInput
            data-testid={computedDataTestId}
            disabled={disabled}
            type={type}
            style={{
              height: '1em',
            }}
            {...field}
            value={field.value || ''}
            onInput={(event) => form.setFieldValue(field.name, getNullableEventValue(event))}
            id={field.name}
            placeholder={placeholder}
          />
        </FormRow>
      )}
    </Field>
  );
};

export default FormTextField;
